import { getLocalData } from '@/lib/base/localData';


/**
 * Check user have all roles in given array
 * @param {Array} target array of required permission
 * @returns {Boolean} return result of user access
 */
const hasAllRoles = target => {
  const user = JSON.parse(getLocalData('user'));
  if (!user) return false;
  const roles = user.roles;
  if (!roles) return false;
  return target.every(requiredRole => roles.includes(requiredRole));
};

/**
 * Check user fit any roles in the given array
 * @param {Array} target array of required permission
 * @returns {Boolean} return result of user access
 */
const hasAnyRole = target => {
  const user = JSON.parse(getLocalData('user'));
  if (!user) return false;
  const roles = user.roles;
  if (!roles) return false;
  return target.some(requiredRole => roles.includes(requiredRole));
};

/**
 * 檢查使用者是否為 project manager
 * @returns {Boolean}
 */
const isProjectManager = () => {
  const user = JSON.parse(getLocalData('user'));
  if (!user) return false;
  if (user.roles !== 'manager') return false;
  const mp = user.managed_projects;
  return Array.isArray(mp) && mp.length > 0;
};

/**
 * Project Manager 可存取的 admin 子路由白名單
 */
const PROJECT_MANAGER_ALLOWED_ROUTES = [
  'admin-edit-instrument',
  'admin-edit-output',
  'admin-edit-output-fill',
];

/**
 * 檢查使用者是否可存取特定的 admin 子路由
 * admin 可存取所有路由；project manager 只能存取白名單路由
 * @param {Object} route Vue Router route object (to)
 * @returns {Boolean}
 */
const canAccessAdminRoute = (route) => {
  const user = JSON.parse(getLocalData('user'));
  if (!user) return false;
  if (user.roles === 'admin') return true;
  if (isProjectManager()) {
    return PROJECT_MANAGER_ALLOWED_ROUTES.includes(route.name);
  }
  return false;
};

export { hasAllRoles, hasAnyRole, isProjectManager, canAccessAdminRoute };